'use strict';

function ProductInterests() {
  this.extends = [OnboardingInfo];
  this.id = null;
  this.node = null;
  this.declaredClass = null;

  this.init = function () {
    this._super();

    // Set product interest model values so we can data bind to them in the pug
    if (this.presenter.getModelProperty('account.products_of_interest') != null) {
      var product = void 0;
      for (var i = 0; i < this.presenter.getModelProperty('account.products_of_interest').length; i++) {
        product = this.presenter.getModelProperty('account.products_of_interest')[i];
        if (product === 'loan') this.presenter.setModelProperty('account.loan', true);
        if (product === 'trade') this.presenter.setModelProperty('account.trade', true);
        if (product === 'mortgage') this.presenter.setModelProperty('account.mortgage', true);
      }
    }
  };

  this.initAllReady = function () {};

  this.destroy = function () {
    this._super();
  };

  this.onCompletedStep = function () {
    this.setOnboardingFlow();
    this._super();
  };
}